import SearchEmailHtml from '../messages/templates/search-email.html';

export function EmailInvoiceCtrl (
  $filter,
  $q,
  $rootScope,
  $scope,
  $translate,
  $uibModal,
  $uibModalInstance,
  attachments,
  blockUI,
  companyMessages,
  customer,
  inspection,
  invoice,
  Invoice,
  isSale,
  messages,
  onlinePaymentsApi,
  requestPayment,
  sendInspection,
  sendInvoice,
  sessionObjAPI,
  templatedWording,
  type,
  workshopAPI,
  workshopPayApi
) {
  $scope.attachments     = attachments;
  $scope.block           = blockUI.instances.get('emailInvoiceBlock');
  $scope.company         = sessionObjAPI.company();
  $scope.companyMessages = companyMessages;
  $scope.customer        = customer;
  $scope.inspection      = inspection || {};
  $scope.invoice         = invoice;
  $scope.invoiceApi      = new Invoice($scope.invoice);
  $scope.isSale          = isSale;
  $scope.requestPayment  = requestPayment;
  $scope.selected        = [];
  $scope.sendInspection  = sendInspection;
  $scope.sendInvoice     = sendInvoice;
  $scope.type            = type;

  $scope.addAttachments = function (selected) {
    $scope.verifying = true;

    if ($rootScope.Company.hasIntegration('vehicle-visuals') && selected.length) {
      workshopAPI.post('/invoice/check_for_vehicle_visuals', selected, 'attachments')
      .then(( result = {} ) => {
        if ( result.data ) {
          $scope.email.message = `${ $scope.email.message }<br>${ result.data }`;
        }

        $scope.email.invoice_attachment_id = selected;

        $scope.$emit('flipModal');
      })
      .catch(err => {
        messages.error(err);
      })
      .finally(() => {
        $scope.verifying = false;
      });
    }
    else {
      $scope.email.invoice_attachment_id = selected;
      $scope.verifying                   = false;

      $scope.$emit('flipModal');
    }
  };

  $scope.addEmails = function () {
    $uibModal.open({
      templateUrl: SearchEmailHtml,
      windowClass: 'lg-modal',
      controller : 'SearchEmailAddressModalCtrl',
      resolve    : {
        emails: () => workshopAPI.get('/customers/email_list', [$scope.customer.id])
      }
    }).result
    .then(data => {
      let input = $scope.email.email ? `${$scope.email.email}; ` : '';

      input += data.map(elem => elem.email)
      .join('; ');

      $scope.email = $scope.buildEmail(input);
    });
  };

  $scope.addTemplates = function () {
    templatedWording.addTemplate('email')
    .then(templates => {
      angular.forEach(templates, template => {
        $scope.email.message = $scope.email.message ?
          `${ $scope.email.message }

          ${ template.wording }` :
          template.wording;
      });
    });
  };

  $scope.buildEmail = function ( email = $scope.customer.email ) {
    return {
      email                ,
      id                   : $scope.customer.id,
      inspection_id        : $scope.inspection.id,
      invoice_attachment_id: $scope.selected,
      invoice_id           : $scope.invoice.id,
      message              : $scope.companyMessages.invoice_email_message,
      request_payment      : $scope.isOnlinePaymentAvailable() && $scope.requestPayment,
      send_inspection      : $scope.sendInspection,
      send_invoice         : $scope.sendInvoice,
      subject              : $filter('htmlToPlainText')($translate.instant('JS_SPACE.EMAIL.VARIABLE_SUBJECT', {
        name: $scope.company.company_name,
        num : $scope.invoice.invoice_number ? ` number ${$scope.invoice.invoice_number}` : '',
        type: $scope.type
      }))
    };
  };

  $scope.isOnlinePaymentAvailable = function () {
    return !$scope.invoiceApi.type('quote')
      && ($scope.isWorkshopPayAvailable()
      || $rootScope.Company.hasIntegration('tillpayments-online'));
  };

  $scope.isWorkshopPayAvailable = function () {
    return workshopPayApi.isPaymentRequestAvailable($scope.invoice, $scope.isSale);
  };

  $scope.selectAttachments = function () {
    $scope.$emit('flipModal');
  };

  $scope.send = function () {
    $scope.block.start($translate.instant('GENERAL_SPACE.MESSAGE.SENDING'));

    return $q.when()
    .then(() => !$scope.isSale && $scope.email.request_payment ?
      onlinePaymentsApi.sendEmailRequest($scope.email, $scope.customer) :
      workshopAPI.post('/invoice/email_invoice_photos', $scope.email, 'customer')
    )
    .then(() => $scope.invoiceApi.type('quote') ? $scope.invoiceApi.save() : $q.when())
    .then(() => {
      $uibModalInstance.close();
    })
    .catch(err => {
      messages.error(err);
    })
    .finally(() => {
      $scope.block.stop();
    });
  };

  if (!$scope.isSale) {
    $scope.$watch('email.request_payment', requestPayment => {
      $scope.email.message = requestPayment ? $scope.companyMessages.default_payment_request : $scope.companyMessages.invoice_email_message;
    });
  }

  $scope.email = $scope.buildEmail();
}
